//@flow
import type {
  State,
  IdiomaUsuario,
  MapConjuntoPermissaoMedidasPorTipoAtivo,
  TipoAtivo,
} from "../../state";

export const getIdiomaUsuario = (state: State): IdiomaUsuario =>
  state.usuario.idioma;

export const getMapConjuntoPermissaoMedidasPorTipoAtivo = (
  state: State
): MapConjuntoPermissaoMedidasPorTipoAtivo =>
  state.usuario.permissoesMedidasPorTipoAtivo;

export const getTiposDeAtivosPermitidos = (state: State): Array<TipoAtivo> =>
  state.usuario.tiposDeAtivosPermitidos;
